<template>
    <div class="image-carousel vuetified container-fluid mb-5">
        <div class="row">
            <div v-bind:class="gridClasses" class="position-relative">
                <div class="position-relative">
                    <transition name="fade" mode="out-in">
                        <img :src="image" :key="image" class="w-100 h-auto">
                    </transition>
                    <stamp v-if="hasStamp" class="stamp--overlay" :class="stampClasses"></stamp>
                </div>
                <div class="position-absolute align-items-center image-carousel__actions">
                    <button class="btn btn__round spot-background spot-front-text" @click="next(+1)">
                        <!-- inline style added here to center icon -->
                        <span class="icon-right-arrow" style="transform: translate(1px, -2px)"></span>
                    </button>
                    <button class="btn btn__round spot-background spot-front-text" @click="next(-1)">
                        <!-- inline style added here to center icon -->
                        <span class="icon-left-arrow" style="transform: translate(-3px, -1px)"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Stamp from './../stamp/Stamp'

    export default {
        components: {
            Stamp
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            images: {
                type: Array,
                required: true,
            },
            hasStamp: {
                type: Boolean,
                required: true,
            },
            stampClasses: {
                type: String,
                required: true,
            }
        },
        data () {
            return {
                active: 0,
            }
        },
        computed: {
            gridClasses () {
                switch (this.type) {
                    case 'landscape':
                    default:
                        return 'col-11';
                    case 'square':
                        return 'col-6 offset-3';
                    case 'portrait':
                        return 'col-5 offset-3';
                }
            },
            image () {
                return this.images[this.active];
            }
        },
        methods: {
            next (value) {
                let imagesLength = this.images.length;
                this.active = (imagesLength + this.active + value) % imagesLength;
            },
        }
    }
</script>
